// You can write more code here

/* START OF COMPILED CODE */

import BaseScene from "../core/scenes/BaseScene";
import BtnPause from "../core/prefabs/BtnPause";
import UIPositionContainer from "../core/components/UIPositionContainer";
import StartTrafficLights from "../prefabs/StartTrafficLights";
import Scoreboard from "../prefabs/Scoreboard";
import EndScreen from "../prefabs/EndScreen";
import BtnAudio from "../core/prefabs/BtnAudio";
import PickupUI from "../prefabs/PickupUI";
import HelpPopup from "../prefabs/HelpPopup";
import PauseMenu from "../prefabs/PauseMenu";
/* START-USER-IMPORTS */
import UIButton from '../core/components/UIButton';
import Game from './Game';
import { GameSceneData, SceneData, SceneId, TransitionPoint } from '../app-routing';
import { app } from '../core/App';
import { Vehicle } from '../Vehicle';
import { RunSettings } from '../level/RunSettingsHandler';
import { CharacterName } from '../Character';
import { LevelName, LevelNameValues } from '../level/levels/level';
import { RunManager } from '../level/RunManager';
/* END-USER-IMPORTS */

export default class GameUI extends BaseScene {

  constructor() {
    super("GameUI");

    /* START-USER-CTR-CODE */
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // btnPause
    const btnPause = new BtnPause(this, 1845, 74.5);
    this.add.existing(btnPause);

    // startTrafficLights
    const startTrafficLights = new StartTrafficLights(this, 976, -400);
    this.add.existing(startTrafficLights);

    // scoreboard
    const scoreboard = new Scoreboard(this, 960, 82);
    this.add.existing(scoreboard);

    // endScreen
    const endScreen = new EndScreen(this, 960, 384);
    this.add.existing(endScreen);
    endScreen.visible = false;

    // btnAudio
    const btnAudio = new BtnAudio(this, 1845, 74.5);
    this.add.existing(btnAudio);
    btnAudio.visible = false;

    // pickupIcon
    const pickupIcon = this.add.image(925, 1045, "game-32", "icon-passenger-1.png");

    // pickupUI
    const pickupUI = new PickupUI(this, 961, 415);
    this.add.existing(pickupUI);

    // helpPopup
    const helpPopup = new HelpPopup(this, 960, 384);
    this.add.existing(helpPopup);
    helpPopup.visible = false;

    // pauseMenu
    const pauseMenu = new PauseMenu(this, 960, 384);
    this.add.existing(pauseMenu);
    pauseMenu.visible = false;

    // btnPause (components)
    const btnPauseUIPositionContainer = new UIPositionContainer(btnPause);
    btnPauseUIPositionContainer.offsetX = 24;
    btnPauseUIPositionContainer.offsetY = 24;
    btnPauseUIPositionContainer.PinRight = true;
    btnPauseUIPositionContainer.PinTop = true;

    // btnAudio (components)
    const btnAudioUIPositionContainer = new UIPositionContainer(btnAudio);
    btnAudioUIPositionContainer.offsetX = 24;
    btnAudioUIPositionContainer.offsetY = 24;
    btnAudioUIPositionContainer.PinRight = true;
    btnAudioUIPositionContainer.PinTop = true;

    this.btnPause = btnPause;
    this.startTrafficLights = startTrafficLights;
    this.scoreboard = scoreboard;
    this.endScreen = endScreen;
    this.btnAudio = btnAudio;
    this.pickupIcon = pickupIcon;
    this.pickupUI = pickupUI;
    this.helpPopup = helpPopup;
    this.pauseMenu = pauseMenu;

    this.events.emit("scene-awake");
  }

  private btnPause!: BtnPause;
  private startTrafficLights!: StartTrafficLights;
  private scoreboard!: Scoreboard;
  private endScreen!: EndScreen;
  private btnAudio!: BtnAudio;
  private pickupIcon!: Phaser.GameObjects.Image;
  private pickupUI!: PickupUI;
  private helpPopup!: HelpPopup;
  private pauseMenu!: PauseMenu;

  /* START-USER-CODE */

  public static events = {
    Back: 'back',
    Home: 'home',
    Replay: 'replay',
    Pause: 'pause',
    LevelSelect: 'levelSelect',
    NextLevel: 'nextLevel',
    Pickup: 'pickup',
    Dropoff: 'dropoff'
  } as const;

  private sceneData!: SceneData;
  private gameSceneData!: GameSceneData;
  private runSettings!: RunSettings;
  private gameScene!: Game;
  private topBtnStartY: number | undefined;
  private bottomBtnStartY: number | undefined;

  public init(data: SceneData) {
    let gameSceneDataDefaults: GameSceneData = {
      shouldSkip: false
    };

    let runSettingsDefaults: RunSettings = {
      selectedCharacter: CharacterName.Tom,
      selectedLevel: LevelName.Level1,
      instantRestart: false,
      regenOnRestart: true
    };

    this.sceneData = data;
    this.gameSceneData = Object.assign({}, gameSceneDataDefaults, data.gameSceneData);
    this.runSettings = Object.assign({}, runSettingsDefaults, data.runSettings);
  }

  public create() {
    super.create();
    this.editorCreate();

    this.gameScene = this.scene.get(SceneId.Game) as Game;
    this.events.on(GameUI.events.Home, this.onHome, this);
    this.events.on(GameUI.events.LevelSelect, this.onLevelSelect, this);
    this.events.on(GameUI.events.Replay, this.onReplay, this);
    this.events.on(GameUI.events.NextLevel, this.onNextLevel, this);
    this.gameScene.events.on(GameUI.events.Pickup, this.onPickup, this);
    this.gameScene.events.on(GameUI.events.Dropoff, this.onDropoff, this);

    // this.btnBack.on(UIButton.events.clicked, this.gameScene.back, this.gameScene);
    this.btnPause.on(UIButton.events.clicked, this.onPause, this);

    this.scoreboard.setCharacter(this.runSettings.selectedCharacter);

    this.bindGameEvents();

    this.events.once(Phaser.Scenes.Events.SHUTDOWN, this.shutdown, this);

    // this.hideUI();
    this.hideAudioBtn();

    this.gameScene.HasGameUICreateFinished = true;
    this.gameScene.start();
  }

  public showUI() {
    // this.tweens.killTweensOf(this.btnBack);
    this.tweens.killTweensOf(this.btnPause);
    this.tweens.killTweensOf(this.scoreboard);

    // this.btnBack.visible = true;
    this.btnPause.visible = true;
    this.scoreboard.visible = true;
    // this.btnBack.alpha = 0;
    this.btnPause.alpha = 0;
    this.scoreboard.alpha = 0;

    this.add.tween({
      // targets: [this.btnBack, this.btnPause, this.scoreboard],
      targets: [this.btnPause, this.scoreboard],
      alpha: 1,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out
    });
  }

  public hideUI() {
    this.add.tween({
      // targets: [this.btnBack, this.btnPause, this.scoreboard],
      targets: [this.btnPause, this.scoreboard],
      alpha: 0,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: () => {
        // this.btnBack.visible = false;
        this.btnPause.visible = false;
      }
    });
  }

  public showAudioBtn() {
    this.btnAudio.visible = true;
    this.btnAudio.alpha = 0;

    this.add.tween({
      targets: [this.btnAudio],
      alpha: 1,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out
    });
  }

  public onPickup(startX: number, startY: number, icon: string, vehicle: Vehicle, bonus: number) {
    this.pickupIcon.setFrame(icon);
    this.pickupIcon.x = startX;
    this.pickupIcon.y = startY;
    this.pickupIcon.scale = 0.3125;
    this.pickupIcon.alpha = 1;
    this.add.tween({
      targets: [this.pickupIcon],
      scale: 1,
      x: 960,
      y: 390,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    let bns = bonus;
    if (!vehicle.IsPlayer) {
      bns = 0;
    }
    this.pickupUI.showMessage(app.localeHandler.getLocalisedTextById('pickup'), bns, vehicle.CurrentCharacter);
    this.time.addEvent({ delay: 750, callback: this.pickupMid, args: [vehicle], callbackScope: this });
  }

  private pickupMid(vehicle: Vehicle) {
    let xpos = vehicle.x - this.gameScene.cameras.main.scrollX + vehicle.TaxiUI!.passengerIconX;
    let ypos = vehicle.y - this.gameScene.cameras.main.scrollY + vehicle.TaxiUI!.passengerIconY;

    this.add.tween({
      targets: [this.pickupIcon],
      scale: 0,
      x: xpos,
      y: ypos,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: () => {
        this.pickupIcon.alpha = 0;
      }
    });
  }

  public onDropoff(icon: string, vehicle: Vehicle, bonus: number) {
    let xpos = vehicle.x - this.gameScene.cameras.main.scrollX + vehicle.TaxiUI!.passengerIconX;
    let ypos = vehicle.y - this.gameScene.cameras.main.scrollY + vehicle.TaxiUI!.passengerIconY;

    this.pickupIcon.setFrame(icon);
    this.pickupIcon.x = xpos;
    this.pickupIcon.y = ypos;
    this.pickupIcon.scale = 0.3125;
    this.pickupIcon.alpha = 1;
    this.add.tween({
      targets: [this.pickupIcon],
      scale: 1,
      x: 960,
      y: 390,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out
    });
    let bns = bonus;
    if (!vehicle.IsPlayer) {
      bns = 0;
    }
    
    this.pickupUI.showMessage(app.localeHandler.getLocalisedTextById('timeBonus'), bns, vehicle.CurrentCharacter);
    this.time.addEvent({ delay: 750, callback: this.dropoffMid, args: [vehicle], callbackScope: this });
  }

  private dropoffMid(vehicle: Vehicle) {
    this.add.tween({
      targets: [this.pickupIcon],
      scale: 0,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: () => {
        this.pickupIcon.alpha = 0;
      }
    });
  }

  public showTaxiCard() {
    this.scoreboard.showTaxiCard();
  }

  public lowerTrafficLight() {
    app.audioHandler.playSound(this, 'SndBeep1', 'sfx');
    this.startTrafficLights.lowerDown();
  }

  public changeTrafficLightToAmber() {
    app.audioHandler.playSound(this, 'SndBeep1', 'sfx');
    this.startTrafficLights.showAmber();
  }

  public changeTrafficLightToGreen() {
    app.audioHandler.playSound(this, 'SndBeep2', 'sfx');
    this.startTrafficLights.showGreen();
  }

  public raiseTrafficLight() {
    this.startTrafficLights.raiseUp();
  }

  public hideAudioBtn() {
    this.add.tween({
      targets: [this.btnAudio],
      alpha: 0,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: () => {
        this.btnAudio.visible = false;
      }
    });
  }

  public showEndScreen(score: number, highScore: number, earnedPoints: number) {
    this.endScreen.visible = true;
    this.endScreen.activate(score, highScore, earnedPoints, this.runSettings.selectedCharacter);
  }

  public shutdown() {
    if (this?.gameScene?.scene?.isActive() || this?.gameScene?.scene?.isPaused()) this.gameScene.scene.stop();

    this.events.off(GameUI.events.Home, this.onHome, this);
    this.events.off(GameUI.events.LevelSelect, this.onLevelSelect, this);
    this.events.off(GameUI.events.Replay, this.onReplay, this);
    this.events.off(GameUI.events.NextLevel, this.onNextLevel, this);
    this.gameScene.events.off(GameUI.events.Pickup, this.onPickup, this);
    this.gameScene.events.off(GameUI.events.Dropoff, this.onDropoff, this);

    // this.btnBack.off(UIButton.events.clicked, this.gameScene.back, this.gameScene);
    this.btnPause.off(UIButton.events.clicked, this.onPause, this);

    this.unbindGameEvents();

    super.shutdown();
  }

  protected finish() {}

  protected onHome() {
    app.gotoNextScene(this, TransitionPoint.GameLevelSelect, this.sceneData);
  }

  protected onLevelSelect() {
    app.gotoNextScene(this.gameScene, TransitionPoint.GameLevelSelect, this.sceneData);
  }

  protected onReplay() {
    app.gotoNextScene(this.gameScene, TransitionPoint.GameReplay, this.sceneData);
  }

  protected onNextLevel(levelName: LevelNameValues) {
    if (levelName) {
      if (!this.sceneData.runSettings) this.sceneData.runSettings = {};
      this.sceneData.runSettings.selectedLevel = levelName;
    }

    app.gotoNextScene(this.gameScene, TransitionPoint.GameReplay, this.sceneData);
  }

  public showHelp() {
    // this.topBtnStartY = this.btnBack.y;
    this.topBtnStartY = this.btnPause.y;
    this.add.tween({
      // targets: [this.btnBack, this.btnPause],
      targets: [this.btnPause],
      y: { from: this.topBtnStartY, to: -100 },
      duration: 600,
      ease: Phaser.Math.Easing.Back.Out
    });

   // this.gameScene.pause();
   // this.scoreboard.getTimer().stopTimer();

    //app.audioHandler.setChannelPause('sfx', true);
    //app.audioHandler.setChannelPause('music', true);

    this.helpPopup.visible = true;
    this.helpPopup.activate(() => {
      this.onHelpResume();
    });
  }

  protected onHelpResume() {
    //this.gameScene.introHelpComplete();
    //this.scoreboard.getTimer().startTimer();

    //app.audioHandler.setChannelPause('sfx', false);
    //app.audioHandler.setChannelPause('music', false);

    this.add.tween({
      // targets: [this.btnBack, this.btnPause],
      targets: [this.btnPause],
      y: { from: -100, to: this.topBtnStartY },
      duration: 600,
      ease: Phaser.Math.Easing.Back.Out,
      onComplete: () => {
        this.gameScene.introHelpComplete();
      }
    });
  }
  

  protected onPause() {
    // this.topBtnStartY = this.btnBack.y;
    this.topBtnStartY = this.btnPause.y;
    this.add.tween({
      // targets: [this.btnBack, this.btnPause],
      targets: [this.btnPause],
      y: { from: this.topBtnStartY, to: -100 },
      duration: 600,
      ease: Phaser.Math.Easing.Back.Out
    });

    this.gameScene.pause();
    this.scoreboard.getTimer().pauseTimer();

    app.audioHandler.setChannelPause('sfx', true);
    app.audioHandler.setChannelPause('music', true);

    this.pauseMenu.visible = true;
    this.pauseMenu.activate(() => {
      this.onResume();
    });
  }

  protected onResume() {
    this.gameScene.resume();
    this.scoreboard.getTimer().unpauseTimer();

    app.audioHandler.setChannelPause('sfx', false);
    app.audioHandler.setChannelPause('music', false);

    this.add.tween({
      // targets: [this.btnBack, this.btnPause],
      targets: [this.btnPause],
      y: { from: -100, to: this.topBtnStartY },
      duration: 600,
      ease: Phaser.Math.Easing.Back.Out
    });
  }

  // Pass through all game events we get to the game scene.
  protected bindGameEvents() {

    this.gameScene.events.on(GameUI.events.Pickup, () => {
      this.scoreboard.getTimer().resetTimer().startTimer();
    });
    this.gameScene.events.on(GameUI.events.Dropoff, () => {
      this.scoreboard.getTimer().stopTimer();
    });
  }

  // Clean up any game events we've been passing to the game scene.
  protected unbindGameEvents() {
    this.gameScene.events.off(GameUI.events.Pickup);
    this.gameScene.events.off(GameUI.events.Dropoff);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
